import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\ServiceController::drywall
* @see app/Http/Controllers/ServiceController.php:17
* @route '/sluzby/montaze-sadrokartonu'
*/
export const drywall = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: drywall.url(options),
    method: 'get',
})

drywall.definition = {
    methods: ["get","head"],
    url: '/sluzby/montaze-sadrokartonu',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ServiceController::drywall
* @see app/Http/Controllers/ServiceController.php:17
* @route '/sluzby/montaze-sadrokartonu'
*/
drywall.url = (options?: RouteQueryOptions) => {
    return drywall.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ServiceController::drywall
* @see app/Http/Controllers/ServiceController.php:17
* @route '/sluzby/montaze-sadrokartonu'
*/
drywall.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: drywall.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ServiceController::drywall
* @see app/Http/Controllers/ServiceController.php:17
* @route '/sluzby/montaze-sadrokartonu'
*/
drywall.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: drywall.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ServiceController::blownInsulation
* @see app/Http/Controllers/ServiceController.php:22
* @route '/sluzby/foukana-izolace'
*/
export const blownInsulation = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: blownInsulation.url(options),
    method: 'get',
})

blownInsulation.definition = {
    methods: ["get","head"],
    url: '/sluzby/foukana-izolace',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ServiceController::blownInsulation
* @see app/Http/Controllers/ServiceController.php:22
* @route '/sluzby/foukana-izolace'
*/
blownInsulation.url = (options?: RouteQueryOptions) => {
    return blownInsulation.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ServiceController::blownInsulation
* @see app/Http/Controllers/ServiceController.php:22
* @route '/sluzby/foukana-izolace'
*/
blownInsulation.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: blownInsulation.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ServiceController::blownInsulation
* @see app/Http/Controllers/ServiceController.php:22
* @route '/sluzby/foukana-izolace'
*/
blownInsulation.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: blownInsulation.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ServiceController::screed
* @see app/Http/Controllers/ServiceController.php:27
* @route '/sluzby/betonova-sterka'
*/
export const screed = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: screed.url(options),
    method: 'get',
})

screed.definition = {
    methods: ["get","head"],
    url: '/sluzby/betonova-sterka',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ServiceController::screed
* @see app/Http/Controllers/ServiceController.php:27
* @route '/sluzby/betonova-sterka'
*/
screed.url = (options?: RouteQueryOptions) => {
    return screed.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ServiceController::screed
* @see app/Http/Controllers/ServiceController.php:27
* @route '/sluzby/betonova-sterka'
*/
screed.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: screed.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ServiceController::screed
* @see app/Http/Controllers/ServiceController.php:27
* @route '/sluzby/betonova-sterka'
*/
screed.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: screed.url(options),
    method: 'head',
})

const ServiceController = { drywall, blownInsulation, screed }

export default ServiceController